import classNames from "classnames";
import { Icon, type IconProps } from "./Icon";
import { IconType } from "./IconType";

export interface Props extends Omit<IconProps, "type"> {
  isActive?: boolean;
}

export const TeaserToggleIcon = ({ isActive, className, ...rest }: Props) => {
  return (
    <Icon
      type={isActive ? IconType.ZcaretUp : IconType.ZcaretDown}
      className={classNames(className, "d-flex i-24")}
      {...rest}
    />
  );
};
